<template>
  <div>
    <!-- 列表项 -->
    <div class="dynamic_list" v-for="(item, index) in list" :key="item.id">
      <!-- 头部 -->
      <div class="header">
        <div class="img_header" @click="other(item)">
          <div class="img">
            <img
              :src="defaultimg"
              v-if="item.avatar == ' ' || item.avatar == ''"
              alt=""
            />
            <img :src="item.avatar" v-else alt="" />
          </div>
          <div class="infomation">
            <p>
              {{ item.user_nicename }}
              <el-tag
                type="success"
                effect="dark"
                size="mini"
                v-for="(item1, index) in userType"
                :key="index"
                v-show="item1.id == item.user_type"
                >{{ item1.identity }}</el-tag
              >
            </p>
            <span>{{ item.create_time }}</span>
            <span v-show="fenxiang">分享到 : {{ item.space_name }}</span>
          </div>
        </div>
        <!-- 更多 -->
        <div v-show="issshow">
          <el-dropdown size="mini">
            <i class="iconfont iconmore more"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item class="iconfont iconjubao" @click.native="jubao"
                >举报</el-dropdown-item
              >
              <el-dropdown-item
                class="iconfont iconshanchuhuise"
                @click.native="shanchu(item.dynamic_id)"
                >删除</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!-- 文字按钮 评论区域 -->
      <div class="txt">
        <div v-html="item.dynamic_content" class="newsaylist"></div>
        <div class="imgBox clearfix">
          <div
            class="imgList fl"
            v-for="(item1, index) in item.dynamic_wmm"
            :key="index"
          >
            <div
              style="width: 250px; height: 252px"
              v-if="item1.substr(item1.length - 3) == 'mp4'"
            >
              <video
                id="my-video"
                class="video-jss"
                controls
                preload="auto"
                width="250"
                height="252"
                data-setup="{}"
              >
                <source :src="item1" type="video/mp4" />
              </video>
            </div>
            <div style="width: 250px; height: 252px" v-else>
              <el-image
                style="width: 250px; height: 252px"
                :src="item1"
                @click="listqd(item.dynamic_wmm)"
                :preview-src-list="sumlist"
              >
              </el-image>
            </div>
          </div>
        </div>

        <!-- 按钮区域 -->
        <div class="anniu">
          <!-- 转发 -->
          <div
            class="zhuanfa"
            @click="zhuanfa(item)"
            v-if="$route.meta.keepAlive"
          >
            <div :style="iszhuanfa === false ? '' : 'backgroundColor:#4bc2ff'">
              <i
                class="iconfont iconzhuanfa"
                :style="iszhuanfa === false ? '' : 'color:#ffffff'"
              ></i>
            </div>
          </div>
          <!-- 收藏 -->
          <div
            class="shoucang"
            :class="{ active1: item.cstatus == 1 }"
            @click="shoucang(item)"
          >
            <div>
              <i class="iconfont iconcollection-b"></i>
            </div>
          </div>
          <!-- 消息 -->
          <div class="xiaoxi" @click="pllist(item.dynamic_id)">
            <div>
              <i class="iconfont icontubiaozhizuo-"></i>
            </div>
            <span style="color: #66b1ff">({{ item.cmtsum }})</span>
          </div>
          <!-- 喜欢 -->
          <div
            class="xihuan"
            :class="{ active: item.pstatus == 1 }"
            @click="xihuan(item)"
          >
            <div>
              <i class="iconfont iconxin"></i>
            </div>
          </div>
        </div>
        <!-- 评论区域 -->
        <div class="pinglun">
          <input
            :class="{ active2: item.dynamic_id == xiaoxi }"
            v-model="text"
            type="text"
            placeholder="评论"
            ref="clearinput"
            @keyup.enter="search"
            @blur.prevent="changeCount()"
            @input="search($event)"
            @click="pinglun(index)"
          />
        </div>
        <!-- 发表按钮 -->
        <el-button
          type="primary"
          round
          v-model="text"
          size="mini"
          :class="{ isshow: item.dynamic_id == xiaoxi }"
          @click="plfabiao(item.dynamic_id)"
          >发表</el-button
        >
        <!-- 评论列表 -->
        <ul :class="{ active2: item.dynamic_id == xiaoxi }">
          <li v-for="item in arr" :key="item.comment_id">
            <img :src="item.avatar" alt="" />
            <div class="pinglunbox">
              <p>
                <span>{{ item.user_nicename }}</span
                >: {{ item.comment_content }}
              </p>
              <p>
                {{ item.create_time }}
                <span class="hovtext" @click="aa(item)">回复</span>
                <span class="hovtext" @click="bb(item)">删除</span>
              </p>
            </div>
            <div
              class="pinglun"
              style="display: none"
              :class="{ isshow: item.comment_id == xiaoxi2 }"
            >
              <input
                class="huifuinput"
                v-model="text2"
                :class="{ active2: item.dynamic_id == xiaoxi }"
                :placeholder="saymsg"
                @keyup.enter="search2"
                @blur.prevent="changeCount1()"
                @input="search2($event)"
              />
              <!-- 发表按钮 -->
              <el-button
                class="huifubtn"
                type="primary"
                round
                size="mini"
                @click="huifu(item.dynamic_id, item.comment_id)"
                >回复</el-button
              >
            </div>
            <ol>
              <li
                v-for="item1 in item.child"
                :key="item1.comment_id"
                :class="{ active2: item1.dynamic_id == '4vKMGnC8' }"
              >
                <img :src="item1.avatar" alt="" />
                <div>
                  <p>
                    <span>{{ item1.user_nicename }}</span
                    >回复 <span>{{ item.user_nicename }}</span> :
                    {{ item1.comment_content }}
                  </p>
                  <p>
                    {{ item1.create_time }}
                    <span class="hovtext1" @click="bb(item1)">删除</span>
                  </p>
                </div>
              </li>
            </ol>
          </li>
        </ul>
        <!-- 删除弹框 -->
        <delete v-show="ashow"></delete>
        <!-- 举报弹框 -->
        <inform v-show="bshow"></inform>
      </div>
    </div>
    <!-- 点击发分享范围态生成的对话框 -->
    <el-dialog title="转发至" :visible.sync="shareDialogVisible" width="30%">
      <span>
        <el-checkbox-group
          v-model="checkedCities"
          @change="handleCheckedCitiesChange"
        >
          <el-checkbox v-for="item in cities" :label="item" :key="item.id">{{
            item.space_name
          }}</el-checkbox>
        </el-checkbox-group>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="xianshi(1)">取 消</el-button>
        <el-button type="primary" @click="xianshi(2)">确 定</el-button>
      </span>
    </el-dialog>
    <log :pushlog="pushlog" @renoav="isshareDialogVisible"></log>
  </div>
</template>
<script>
import URL from "../../api/index";
import VueEvent from "../../api/eventBus";
import Delete from "../../components/space/delete";
import Inform from "../../components/space/inform";
// import '../../assets/css/video-js.min.css'
// import '../../plugins/video.min.js'
import Log from "./dialog";
import axios from "axios";

export default {
  components: {
    Delete,
    Inform,
    Log,
  },
  props: ["list"],
  data() {
    return {
      saymsg: "",
      //消息
      shareDialogVisible: false,
      xiaoxi: "4vKJdSi7",
      xiaoxi2: "4vNqqJkv",
      // 是否喜欢
      isxihuan: false,
      // 是否收藏
      isshoucang: false,
      // 是否转发
      iszhuanfa: false,
      // 发表品论
      isFaBiao: true,
      defaultimg: require("../../assets/photoico.png"),
      active: true,
      ashow: false,
      bshow: false,
      UserInfo: "",
      getSpaceinfo: "",
      arr: [],
      current: null,
      text: "",
      text2: "",
      checkedCities: [],
      cities: "",
      pagenum: "10",
      issshow: true,
      iteminfo: "",
      // bbb:'{"pic":["http://rjwpublic.oss-cn-qingdao.aliyuncs.com/album/space/dynamic1592534394823.jpg","http://rjwpublic.oss-cn-qingdao.aliyuncs.com/album/space/dynamic1592534388729.jpg"]}',
      userType: [
        { id: "2", identity: "学员" },
        { id: "3", identity: "教师" },
        { id: "4", identity: "校长" },
        { id: "5", identity: "学生" },
        { id: "6", identity: "教育局" },
      ],
      fenxiang: true,
      pushlog: false,
      dynamic_id: "",
      dy_pic: { pic: "" },
      sumlist: [],
      lc: "",
      random: 0,
      isstart: "",
      win: "",
      model: "",
    };
  },
  beforeMount() {},
  mounted() {
    if (this.$route.name == "dynamic") {
      this.model = "最新动态";
    }
    if (this.$route.name == "school") {
      this.model = "学校圈";
    }
    if (this.$route.name == "glass") {
      this.model = "班级圈";
    }
    if (this.$route.name == "saying") {
      this.model = "说说";
    }
    let cookieEnabled = navigator.userAgent.toLocaleLowerCase();
    let wins = [
      {
        sys: "windows nt 5.0",
        alias: "windows 2000",
        name: "Win2000",
      },
      {
        sys: "windows nt 5.1",
        alias: "windows xp",
        name: "WinXP",
      },
      {
        sys: "windows nt 5.2",
        alias: "windows 2003",
        name: "Win2003",
      },
      {
        sys: "windows nt 6.0",
        alias: "Windows Vista",
        name: "WinVista",
      },
      {
        sys: "windows nt 6.1",
        alias: "Windows 7",
        name: "Win7",
      },
      {
        sys: "windows nt 6.2",
        alias: "Windows 8",
        name: "Win8",
      },
      {
        sys: "windows nt 10.0",
        alias: "Windows 10",
        name: "Win10",
      },
    ];
    for (let win of wins) {
      if (
        cookieEnabled.indexOf(win.sys) > -1 ||
        cookieEnabled.indexOf(win.alias) > -1
      ) {
        this.win = win.name;
        localStorage.setItem("winname", win.name);
      }
    }
    this.iteminfo = JSON.parse(window.localStorage.getItem("info"));
    this.random = Date.parse(new Date()) + String(this.iteminfo.user_id);
    this.dynamic_id = "";
    if (this.$route.path == "/space/collection") {
      this.fenxiang = false;
    }
    window.addEventListener("scroll", this.scrollEvent, false);
    this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
    this.getSpaceinfo = JSON.parse(window.localStorage.getItem("getSpaceinfo"));
    // if(this.iteminfo) {
    //   this.issshow = false
    // } else{
    //   this.issshow = true
    // }
    var that = this;
    var userspace_data = {
      token: that.UserInfo.token,
      user_id: that.UserInfo.user_id,
    }; // 关注的空间列表
    this.$post(URL.userspace, userspace_data).then((res) => {
      var cityOptions = res.result;
      that.cities = cityOptions;
    });
  },
  watch: {
    // 使用监听的方式，监听数据的变化
    list(val) {
      // console.log(val)
    },
  },
  methods: {
    listqd(e) {
      var sum = [];
      for (var i = 0; i < e.length; i++) {
        if (e[i].substr(e[i].length - 3) != "mp4") {
          sum.push(e[i]);
        }
      }
      this.sumlist = sum;
    },
    other(e) {
      if (this.getSpaceinfo.space_id == e.space_id) {
        this.$router.push("/space/saying");
      } else {
        localStorage.setItem("iteminfo", JSON.stringify(e));
        this.$router.push("/space/saying");
      }
    },
    scrollEvent() {
      if (
        document.documentElement.scrollTop +
          document.documentElement.clientHeight >=
        document.body.scrollHeight
      ) {
        this.pagenum = Number(this.pagenum) + 10;
        this.$emit("renoav", this.pagenum);
      }
    },
    //转发多选
    handleCheckedCitiesChange(e) {
      this.checkedCities = e;
    },
    aa(e) {
      if (this.xiaoxi2 == e.comment_id) {
        this.xiaoxi2 = "";
      } else {
        this.xiaoxi2 = e.comment_id;
        this.saymsg = "回复 " + e.user_nicename + ":";
      }
    },
    bb(e) {
      var that = this;
      var addComment_data3 = {
        token: that.UserInfo.token,
        commentid: e.comment_id,
      };
      // 删除评论
      this.$post(URL.delComment, addComment_data3).then((res) => {
        that.getdel(e.dynamic_id);
      });
    },
    changeCount() {
      // this.current=null
      this.text = event.currentTarget.value;
    },
    changeCount1() {
      // this.xiaoxi2=''
    },
    search(event) {
      this.text = event.currentTarget.value;
    },
    // 回复
    search2(event) {
      this.text2 = event.currentTarget.value;
    },
    pinglun(e) {
      this.current = e;
    },
    //删除
    shanchu(e) {
      // this.getRecordRjw(e, "删除");
      this.ashow = true;
      var that = this;
      VueEvent.$emit("num", "1");
      VueEvent.$off("tab");
      VueEvent.$on("tab", function (data) {
        var delDynamic_data = {
          token: that.UserInfo.token,
          dynamicid: e,
        };
        //  删除动态
        this.$post(URL.delDynamic, delDynamic_data).then((res) => {
          that.getRjwDel(JSON.parse(localStorage.getItem("loginInfo")), e);
          var aaa = ["删除", e];
          that.$emit("shangchuan", aaa);
          that.$emit("renoav", this.pagenum);
          if (res.state == "0") {
            VueEvent.$emit("ling", "0");
          } else if (res.state == "1") {
            VueEvent.$emit("ling", "1");
          }
        });
      });
    },
    // 回复
    huifu(a, e) {
      // this.getRecordRjw(a + "," + e + "," + this.text2, "回复");
      var that = this;
      var addComment_data2 = {
        token: that.UserInfo.token,
        comment: that.text2,
        dynamic: a,
        comment_id: e,
        comtype: "dynamic",
      };
      // 留言中评论
      this.$post(URL.addComment, addComment_data2).then((res) => {
        that.getdel(a);
        that.xiaoxi2 = "";
        that.text2 = "";
      });
    },
    //发表评论
    plfabiao(e) {
      // console.log(e);
      this.getRjwComment(JSON.parse(localStorage.getItem("loginInfo")), e);
      var that = this;
      if (that.xiaoxi == e) {
        that.xiaoxi = "";
      } else {
        that.xiaoxi = e;
      }
      var addComment_data = {
        token: that.UserInfo.token,
        comment: that.text,
        dynamic: e,
        comtype: "dynamic",
      };
      // 留言中评论
      this.$post(URL.addComment, addComment_data).then((res) => {
        // this.$emit('shuaxin','123');
        that.isFaBiao = false;
        that.pllist(e);
        that.text = "";
      });
    },
    //评论列表
    pllist(e) {
      // this.getRjwLike(JSON.parse(localStorage.getItem("loginInfo")),
      //       e.gsb_id);
      var that = this;
      if (that.xiaoxi == e) {
        that.xiaoxi = null;
      } else {
        that.xiaoxi = e;
      }
      var getCommentList_data = {
        token: this.UserInfo.token,
        dynamic: e,
        comtype: "dynamic",
      };
      this.$post(URL.getCommentList, getCommentList_data).then((res) => {
        that.arr = res.result;
      });
    },
    //删除更新评论
    getdel(e) {
      // this.getRecordRjw(e, "删除评论");
      var that = this;
      var getCommentList_data = {
        token: this.UserInfo.token,
        dynamic: e,
        comtype: "dynamic",
      };
      this.$post(URL.getCommentList, getCommentList_data).then((res) => {
        that.arr = res.result;
      });
    },
    // 点击喜欢
    xihuan(e) {
      // console.log(e.pstatus);

      // 点赞
      if (e.pstatus == 2) {
        this.getRjwLike(
          JSON.parse(localStorage.getItem("loginInfo")),
          e.dynamic_id
        );
      } else {
        this.getRjwUnLike(
          JSON.parse(localStorage.getItem("loginInfo")),
          e.dynamic_id
        );
      }
      var that = this;
      e.pstatus = e.pstatus == "1" ? "2" : "1";
      var data = {
        token: that.UserInfo.token,
        dynamicid: e.dynamic_id,
      };
      //点赞/取消点赞
      this.$post(URL.Praise, data).then((res) => {
        var title = res.msg;
        var aaa = [title, e.dynamic_id];
        this.$emit("shangchuan", aaa);
      });
      this.$emit("renoav", this.pagenum);
    },
    renovalist() {
      // this.$emit('renova','2')
    },
    // 点击转发
    zhuanfa(item) {
      localStorage.setItem("zhuan_data", JSON.stringify(item));
      this.title = "转发至";
      this.shareDialogVisible = true;
    },
    // 点击收藏
    shoucang(e) {
      var that = this;
      if (this.$route.path == "/space/collection") {
        this.pushlog = true;
        this.dynamic_id = e.dynamic_id;
        that.getRjwUnCol(
          JSON.parse(localStorage.getItem("loginInfo")),
          e.dynamic_id
        );
      } else {
        e.cstatus = e.cstatus == "1" ? "2" : "1";
        if (e.cstatus == 1) {
          that.getRjwCollect(
            JSON.parse(localStorage.getItem("loginInfo")),
            e.dynamic_id
          );
        } else {
          that.getRjwUnCollect(
            JSON.parse(localStorage.getItem("loginInfo")),
            e.dynamic_id
          );
        }
        var data = {
          token: that.UserInfo.token,
          coltype: "dynamic",
          content: e.dynamic_id,
        };
        this.titletext = false;
        //收藏取消收藏
        this.$post(URL.collect, data).then((res) => {
          // if (res.msg == "收藏") {
          // that.getRecordRjw(e.dynamic_id, "收藏");
          // } else {
          // that.getRecordRjw(e.dynamic_id, "取消收藏");
          // }
          var title = res.msg;
          var aaa = [title, e.dynamic_id];
          this.$emit("shangchuan", aaa);
        });
        this.$emit("renoav", this.pagenum);
      }
    },
    isshareDialogVisible(val) {
      var that = this;
      if (val == 1) {
        that.pushlog = false;
      } else if (val == 2) {
        var data = {
          token: that.UserInfo.token,
          coltype: "dynamic",
          content: that.dynamic_id,
        };
        this.titletext = false;
        //收藏取消收藏
        this.$post(URL.collect, data).then((res) => {
          this.$emit("renoav", this.pagenum);
        });
        that.pushlog = false;
      }
    },
    jubao() {
      VueEvent.$emit("val", "3");
      this.bshow = true;
      VueEvent.$emit("bao", "1");
    },
    xianshi(e) {
      var that = this;
      if (e == 1) {
        that.shareDialogVisible = false;
      } else if (e == 2) {
        that.checkedCities.forEach(function (e) {
          that.addzhuanfa(e.space_id);
        });
      }
    },
    addzhuanfa(e) {
      var that = this;
      var zhuanfa_data = JSON.parse(window.localStorage.getItem("zhuan_data"));
      // console.log(zhuanfa_data.dynamic_wmm);

      that.dy_pic.pic = zhuanfa_data.dynamic_wmm;
      var data = {
        token: that.UserInfo.token,
        content: zhuanfa_data.dynamic_content,
        wmm: JSON.stringify(that.dy_pic),
        spaceid: e,
        forward: zhuanfa_data.dynamic_id,
        fromapp: "",
      };
      // console.log(data);

      this.$post(URL.transpondDynamic, data).then((res) => {
        if (res.state == 0) {
          this.$message({
            message: "转发成功",
          });
        }
        that.$emit("renoav", this.pagenum);
        that.shareDialogVisible = false;
      });
    },
    //上报数据-删除
    getRjwDel(hh, row) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_delete",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的删除功能",
          data: {
            function: this.model,
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            delete_id: row,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    //上报数据-点赞
    getRjwLike(hh, row) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_praise",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的点赞功能",
          data: {
            function: this.model,
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            bythumbup_id: row,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    //上报数据-取消点赞
    getRjwUnLike(hh, row) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_praisecancel",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的取消点赞功能",
          data: {
            function: this.model,
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            cancelthumbup_id: row,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    //上报数据-评论
    getRjwComment(hh, row) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_comment",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的评论功能",
          data: {
            function: this.model,
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            bycomment_id: row,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    //上报数据-收藏
    getRjwCollect(hh, row) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_collect",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的收藏功能",
          data: {
            function: this.model,
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            bycollect_id: row,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    //上报数据-取消收藏
    getRjwUnCollect(hh, row) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_collectcancel",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的取消收藏功能",
          data: {
            function: this.model,
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            bycancelcollect_id: row,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    //上报数据-取消收藏
    getRjwUnCol(hh, row) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_collectcancel",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的取消收藏功能",
          data: {
            function: "收藏列表",
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            bycancelcollect_id: row,
            source: "收藏的说说",
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
  },
};
</script>
<style lang="less">
.active2 {
  display: block !important;
}
/*分享*/
.newsaylist a {
  color: #1381f2;
}
.newsaylist,
.newsaylist > div:nth-child(1) {
  font-size: 17px;
  line-height: 24px;
  margin: 16px 16px 16px 0;
}
.newsaylist > div:nth-child(2) {
  height: 116px !important;
  padding: 10px !important;
  margin-left: 0px !important;
}
.newsaylist > div:nth-child(2) > div:nth-child(1) {
  width: 95px !important;
}
.newsaylist > div:nth-child(2) > div:nth-child(2) {
  font-size: 24px !important;
  line-height: 108px !important;
  margin-left: 25px;
  float: left !important;
}

.newsaylist > div:nth-child(2) > div:nth-child(2) a {
  color: #1381f2 !important;
}
.navnone {
  display: none;
}
.right-top > div:last-child {
  margin-bottom: 40px;
}
.dynamic_list {
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(15, 26, 47, 0.06);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 25px 25px 18px;
  overflow: hidden;
  margin-bottom: 12px;
  .header {
    width: 100%;
    overflow: hidden;

    .img_header {
      float: left;
      cursor: pointer;
      .img {
        padding: 8px 14px 0 3px;
        float: left;
        img {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          overflow: hidden;
          border: 1px solid #ccc;
        }
      }
      .infomation {
        float: left;
        color: #898989;
        p {
          padding: 7px 0 4px 0;
          font-size: 14px;
          color: #000;
          .el-tag {
            margin-left: 10px;
          }
        }
        span {
          font-size: 12px;
          padding-right: 5px;
        }
      }
    }
    .el-dropdown {
      float: right;
      font-size: 20px;
      cursor: pointer;
    }
  }
  .txt {
    float: right;
    width: 768px;
    // margin-top: 20px;
    .isshow {
      display: block !important;
    }
    p {
      color: #2b2b2b;
      font-size: 16px;
      line-height: 25px;
    }
    .imgBox {
      // display: flex;
      flex-wrap: wrap;
      margin: 0 !important;
      // justify-content: flex-start;
      // justify-content: flex-start
      //   align-items: left;
      //   width:100%;
      //   flex-wrap: wrap;
      .imgList {
        margin-right: 5px;
        margin-bottom: 5px;
        float: left;
        //     display: flex;
        // justify-content: center;
        // align-items: center;
        // flex-direction: column;
        // width:25%;
        // padding-top: 10px;
        // padding-bottom: 10px;
      }
    }
    .anniu {
      height: 60px;
      line-height: 60px;
      padding-top: 20px;
      box-sizing: border-box;
      padding-left: 460px;
      user-select: none;
      .xihuan,
      .xiaoxi,
      .shoucang,
      .zhuanfa {
        line-height: 39px;
        float: right;
        line-height: 35px !important;
        font-size: 19px !important;
        float: right !important;
        margin-right: 23px;
        .iconzhuanfa,
        .iconcollection-b {
          line-height: 35px !important;
          font-size: 19px !important;
        }
        div {
          float: left;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: #ebebeb;
          text-align: center;
          cursor: pointer;
          margin-right: 10px;
          i {
            line-height: 40px;
            color: #b6b6b6;
            font-size: 23px;
          }
        }
        span {
          color: #2b2b2b;
          font-size: 16px;
        }
      }
      .xihuan:hover {
        div {
          background-color: #ff5656 !important;
          i {
            color: #fff !important;
          }
        }
      }
      .xiaoxi:hover {
        div {
          background: #66b1ff !important;
        }
        i {
          color: #fff !important;
        }
      }
      .shoucang:hover {
        div {
          background-color: #ffcd56 !important;
          .iconcollection-b {
            color: #fff !important;
          }
        }
      }
      .zhuanfa:hover {
        div {
          background: #4bc2ff !important;
        }
        i {
          color: #ffffff;
        }
      }
    }
    .pinglun {
      cursor: text;
      box-sizing: border-box;
      margin-top: 15px;
      // display: none;
      width: 99%;

      input {
        display: none;
        outline: none;
        border: 0;
        width: 97%;
        height: 30px;
        text-indent: 1rem;
        line-height: 50px;
        background-color: #ffffff;
        border-radius: 4px;
        border: solid 1px #d3d7e0;
        font-size: 15px;
      }
      .huifuinput {
        height: 23px;
        font-size: 10px;
        width: 87%;
      }
      .huifubtn {
        margin-top: 10px !important;
        display: block;
      }
    }
    .isshow {
      display: block !important;
    }
    .el-button {
      float: right;
      margin-top: 10px;
      margin-right: 20px;
      display: none;
    }

    .active div {
      background-color: #ff5656 !important;
      .iconxin {
        color: #fff !important;
      }
    }
    .active span {
      color: #295c9d !important;
    }
    .active1 div {
      background-color: #ffcd56 !important;
      .iconcollection-b {
        color: #fff !important;
      }
    }
    .active2 .pinglunbox:hover {
      .hovtext {
        cursor: pointer;
        color: #295c9d;
        margin-left: 4px;
        visibility: inherit !important;
      }
    }
    .active2 ol li:hover {
      .hovtext1 {
        cursor: pointer;
        color: #295c9d;
        margin-left: 4px;
        visibility: inherit !important;
      }
    }
    .active2 .hovtext {
      visibility: hidden !important;
    }
    .active2 .hovtext1 {
      visibility: hidden !important;
    }
  }
  ul {
    display: none;
    float: left;
    padding: 8px 10px 0;
    width: 98%;
    li {
      overflow: hidden;
      padding-top: 10px;
      width: 100%;
      img {
        display: inline-block;
        width: 33px;
        height: 33px;
        vertical-align: middle;
        margin-right: 1em;
        border-radius: 50%;
      }
      div {
        display: inline-block;
        vertical-align: middle;
        p {
          span {
            // cursor: pointer;
            color: #295c9d;
          }
          &:first-child {
            font-size: 12px;
            line-height: 20px;
          }
          &:last-child {
            font-size: 12px;
            line-height: 20px;
            // color: #409EFF;
          }
        }
      }
    }
  }
  ol {
    margin-left: 48px;
  }
}
.show {
  display: block;
}
.el-checkbox {
  line-height: 40px;
}
.video-jss {
  width: 100%;
  display: block;
  // vertical-align: top;
  box-sizing: border-box;
  color: #fff;
  background-color: #000;
  position: relative;
  padding: 0;
  font-size: 10px;
  line-height: 1;
  font-weight: 400;
  font-style: normal;
  font-family: Arial, Helvetica, sans-serif;
  word-break: initial;
}
.el-image-viewer__canvas img {
  margin: 0;
}
</style>